import { useRelayEnvironment } from 'react-relay/hooks';
import { commitLocalUpdate } from 'relay-runtime';
import { Environment } from 'relay-runtime/lib/store/RelayStoreTypes';
import { ModelKeys } from './createKeys';

type NodeTypeName =
  | 'Appointment'
  | 'AppointmentType'
  | 'Availability'
  | 'Broadcast'
  | 'ChatActivity'
  | 'Diagnosis'
  | 'Facility'
  | 'FileUpload'
  | 'Followup'
  | 'Group'
  | 'GroupInvite'
  | 'Insurance'
  | 'Message'
  | 'MessageTemplate'
  | 'Offer'
  | 'Organization'
  | 'Patient'
  | 'PatientForm'
  | 'PatientFormTemplate'
  | 'PatientMessageTemplate'
  | 'Provider'
  | 'Recalls'
  | 'Referral'
  | 'Reminder'
  | 'Setting'
  | 'Telehealth'
  | 'Upload'
  | 'User'
  | 'WaitingRoom'
  | 'WaitingRoomPatient'
  | 'Waitlist'
  | 'PatientContact';

export function base64(i: string): string {
  return Buffer.from(i, 'ascii').toString('base64');
}
export function toGlobalId(type: NodeTypeName, id?: string | number): string {
  return id ? base64([type, id].join(':')) : '';
}

export function invalidateStore(environment: Environment) {
  commitLocalUpdate(environment, (store) =>
    // @ts-ignore
    store.invalidateStore(),
  );
}

export function useInvalidateStores() {
  const environment = useRelayEnvironment();

  const updateStores = (entityId: string, fetchKey?: ModelKeys['fetchKey']) => {
    if (fetchKey) {
      commitLocalUpdate(environment, (store) => {
        const entityRecord = store.get(
          toGlobalId(fetchKey as NodeTypeName, entityId),
        );
        if (entityRecord) {
          entityRecord.invalidateRecord();
        }
      });
    } else {
      invalidateStore(environment);
    }
  };

  return updateStores;
}
